import {getErrorToast} from './toasts'
import api from '../../api'

const generatePdf = async (data: {
    title?: string
    body: string
    setLoading?: (loading: boolean) => void
}) => {
    const {title, body, setLoading} = data
    try {
        setLoading?.(true)

        const res = await api<{href: string}>('documents', 'generatePdf', {title, body})
        const href = (res as any)?.data?.href

        if (!href) throw new Error('PDF href is empty')

        const a = document.createElement('a')
        a.href = href
        a.download = title ? `${title}.pdf` : 'document.pdf'
        a.target = '_blank'
        a.rel = 'noopener'
        document.body.appendChild(a)
        a.click()
        a.remove()
    } catch (e) {
        getErrorToast()
    } finally {
        setLoading?.(false)
    }
}

export default generatePdf
